/* footer menu items */
const staticContent = [
  {
    title: 'Säkerhet',
    url: '/om/sakerhet',
    sys: {
      id: 'VVGsxfcEmsU6OmycuAayc',
      __typename: 'Sys',
    },
    contentCollection: {
      items: [
        {
          title: 'Kundsäkerhet',
          url: '/om/sakerhet/sakerhetsarbete',
          sys: {
            id: '6A0kFTFLlSwaMYAgi402Ok',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Falska mail',
          url: '/om/sakerhet/falska-mail',
          sys: {
            id: '4tGqJNBKes0Wy64qis2g0S',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Anmäl störande reklam',
          url:
            'https://blocket.zendesk.com/hc/sv/articles/115005689489-Varf%C3%B6r-f%C3%A5r-jag-st%C3%B6rande-reklam-',
          sys: {
            id: '2XwGcAMMkwSEmiAqMcgWI4',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
      ],
      __typename: 'MenuSectionContentCollection',
    },
    __typename: 'MenuSection',
  },
  {
    title: 'Villkor',
    url: '/om/villkor',
    sys: {
      id: '1BCIha2Hru48UAUksUwYa0',
      __typename: 'Sys',
    },
    contentCollection: {
      items: [
        {
          title: 'Användarvillkor',
          url: '/om/villkor/anvandarvillkor',
          sys: {
            id: '2bivLi7hVqCK42E4e6kakg',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
      ],
      __typename: 'MenuSectionContentCollection',
    },
    __typename: 'MenuSection',
  },
  {
    title:
      'För företag                                                                                                                                                                                                  ',
    url: '/for-foretag',
    sys: {
      id: '3Mvidvz6Ni4ugEMuWQYkUW',
      __typename: 'Sys',
    },
    contentCollection: {
      items: [
        {
          title: 'Öppna butik',
          url: '/for-foretag/marknadsforing/kop-och-salj/oppna-butik',
          sys: {
            id: '4F9T3S08taCQosquYq80ys',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Marknadsföring',
          url: '/for-foretag/marknadsforing',
          sys: {
            id: '6rnpwJld6wqi8ySWmu2qkQ',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Inloggning för butiker',
          url: 'https://www.blocket.se/store/login',
          sys: {
            id: '4KIRJMvGmiBvZU550d3Lau',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Administrera butiksannonser',
          url: 'https://www.blocket.se/store/list',
          sys: {
            id: '4KIRJMvGmiBvZU550d3Lap',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
      ],
      __typename: 'MenuSectionContentCollection',
    },
    __typename: 'MenuSection',
  },
  {
    title: 'Blocket',
    url: null,
    sys: {
      id: '5r2zBT9bUIi42wmwky2Swk',
      __typename: 'Sys',
    },
    contentCollection: {
      items: [
        {
          title: 'Om Blocket',
          url: '/om',
          sys: {
            id: '2DpZ2LY2ikg4EIckUm2O4C',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Press',
          url: '/om/press',
          sys: {
            id: 'KWPWG3oDAWWSmo0iW48i4',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Jobba på Blocket',
          url: 'https://www.blocket.career/',
          sys: {
            id: '7dOWoR92r62SqISA4Cgg4G',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Kontakta oss',
          url: '/om/kontakta-oss',
          sys: {
            id: '7swz7TPGLeIk2SUY8e6CaU',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
        {
          title: 'Inspiration',
          url: '/inspiration',
          sys: {
            id: '4zP2ZApgNj55Vg4lMVMz8J',
            __typename: 'Sys',
          },
          __typename: 'MenuItem',
        },
      ],
      __typename: 'MenuSectionContentCollection',
    },
    __typename: 'MenuSection',
  },
]
export default staticContent
